import commonContentDefinitions from "@client/content/definitions.json";
import { type GenericMap, type SettingDefinition } from "@client/types";
import commonDefinitions from "./definitions.json";

export const COMMON_DEFINITIONS_ALL: GenericMap<SettingDefinition> = {
  ...commonDefinitions,
  ...commonContentDefinitions
};
